import React from "react";
import Storylist from "../StorylistFemaleToMale";
import { observer } from "mobx-react";

const lists = [
  ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o"],
  ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o"],
  ["p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "aa", "ab", "ac", "ad", "ae"],
  ["p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "aa", "ab", "ac", "ad", "ae"],
  ["p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "aa", "ab", "ac", "ad", "ae"]
];

export default observer(({ artistName, book, order, setpImage }) => (
  <div className="story-selection pd-15">
    <img
      style={{
        padding: "16px 0px 38px",
        width: "100%",
        height: "auto"
      }}
      src={require(`../../imgs/${setpImage}`)}
    />

    <div className="step">
      <span className="step-title-alt">{"STEP 1 "}</span>
      <span className="step-txt">{"あなたのパートナーの「ちょっとした短所」を２つ選んでください。"}</span>
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v)}
        list={lists[0]}
        onSelect={selected => book.setFemaleToMaleStory(0, selected)}
        selected={book.stories[0]}
        storyCounter={"A"}
      />
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v)}
        list={lists[1]}
        onSelect={selected => book.setFemaleToMaleStory(1, selected)}
        selected={book.stories[1]}
        storyCounter={"B"}
      />
    </div>

    <div className="step step-2">
      <span className="step-title-alt">{"STEP 2 "}</span>
      <span className="step-txt">{"あなたにとってのパートナーの「魅力」を３つ選んでください。"}</span>
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v)}
        list={book.children > 0 ? lists[2] : lists[2].filter(key => key !== "s")} // こどもいなければ子煩悩を除外
        onSelect={selected => book.setFemaleToMaleStory(2, selected)}
        selected={book.stories[2]}
        storyCounter={"C"}
      />
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v)}
        list={book.children > 0 ? lists[3] : lists[3].filter(key => key !== "s")}
        onSelect={selected => book.setFemaleToMaleStory(3, selected)}
        selected={book.stories[3]}
        storyCounter={"D"}
      />
      <Storylist
        artistName={artistName}
        book={book}
        disabled={book.stories.map(v => v)}
        list={book.children > 0 ? lists[4] : lists[4].filter(key => key !== "s")}
        onSelect={selected => book.setFemaleToMaleStory(4, selected)}
        selected={book.stories[4]}
        storyCounter={"E"}
      />
    </div>
    <div
      style={{
        "paddingTop": "16px",
      }}
      className="btn-wrap"
    >
      <button
        disabled={book.stories.indexOf("") !== -1}
        onClick={() => order.saveStories()}
        className="btn product-btn"
      >
        保存して次へ
        <img
          src="https://cdn.shopify.com/s/files/1/0012/2568/7076/files/arrow-right-purple.png?13701503969354364487"
          className="btn-arrow"
        />
      </button>
    </div>
  </div>
));



// WEBPACK FOOTER //
// ./src/components/steps/StorySelectionFemaleToMale.js